module.exports = __webpack_public_path__ + "img/COMBO FLOWER PURPLE.06ea8ee.svg";